export default __webpack_public_path__ + "static/media/hrd.2b21bdbb.png";